import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function UpdateIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 66 60">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33 10C39.4329 10 44.9499 12.6967 48.6061 17.5H43.75V22.5H57.1875V10H51.8125V13.1759C47.1763 7.95628 40.5364 5 33 5C18.1573 5 6.125 16.1929 6.125 30H11.5C11.5 18.9543 21.1259 10 33 10ZM33 50C26.5671 50 21.0501 47.3033 17.3939 42.5H22.25V37.5H8.8125V50H14.1875V46.8241C18.8237 52.0437 25.4636 55 33 55C47.8427 55 59.875 43.8071 59.875 30H54.5C54.5 41.0457 44.8741 50 33 50ZM33.0009 39.9959C34.4856 39.9959 35.6893 38.8766 35.6893 37.4959C35.6893 36.1152 34.4856 34.9959 33.0009 34.9959C31.5161 34.9959 30.3125 36.1152 30.3125 37.4959C30.3125 38.8766 31.5161 39.9959 33.0009 39.9959ZM35.6972 17.4959H30.3204V32.4959H35.6972V17.4959Z"
          fill="#213A6D"
        />
      </g>
    </SvgIcon>
  );
}
